import styled from 'styled-components'

export const MapErrorText = styled.div`
	font-size: 1.5em;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`
MapErrorText.displayName = 'MapErrorText'
